<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  components: { ContentLoader },
  props: {
    animate: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<template>
  <content-loader
    width="1276"
    height="210"
    viewBox="0 0 1276 180"
    :speed="animate ? 2 : 0"
    primaryColor="#F9FAFF"
    secondaryColor="#D8DFF6"
    :primaryOpacity="0.9"
    :secondaryOpacity="0.25"
  >
    <!-- <rect x="48" y="233" width="151" height="83" rx="4" />
    <rect x="366" y="234" width="151" height="83" rx="4" />
    <rect x="684" y="235" width="151" height="83" rx="4" />
    <rect x="1002" y="236" width="151" height="83" rx="4" />
    <rect x="47" y="326" width="152" height="20" rx="4" />
    <rect x="365" y="327" width="152" height="20" rx="4" />
    <rect x="683" y="328" width="152" height="20" rx="4" />
    <rect x="1001" y="329" width="152" height="20" rx="4" /> -->
    <rect x="32" y="25" width="191" height="25" rx="4" />
    <rect x="32" y="60" width="191" height="25" rx="4" />
    <rect x="32" y="95" width="191" height="25" rx="4" />
    <rect x="32" y="130" width="191" height="25" rx="4" />
    <rect x="32" y="165" width="191" height="25" rx="4" />
    <rect x="335" y="19" width="33" height="34" rx="4" />
    <rect x="475" y="19" width="33" height="34" rx="4" />
    <rect x="615" y="19" width="33" height="34" rx="4" />
    <rect x="755" y="19" width="33" height="34" rx="4" />
    <rect x="895" y="19" width="33" height="34" rx="4" />
    <rect x="1035" y="19" width="33" height="34" rx="4" />
    <rect x="335" y="55" width="33" height="34" rx="4" />
    <rect x="475" y="55" width="33" height="34" rx="4" />
    <rect x="615" y="55" width="33" height="34" rx="4" />
    <rect x="755" y="55" width="33" height="34" rx="4" />
    <rect x="895" y="55" width="33" height="34" rx="4" />
    <rect x="1035" y="55" width="33" height="34" rx="4" />
    <rect x="335" y="90" width="33" height="34" rx="4" />
    <rect x="475" y="90" width="33" height="34" rx="4" />
    <rect x="615" y="90" width="33" height="34" rx="4" />
    <rect x="755" y="90" width="33" height="34" rx="4" />
    <rect x="895" y="90" width="33" height="34" rx="4" />
    <rect x="1035" y="90" width="33" height="34" rx="4" />
    <rect x="335" y="125" width="33" height="34" rx="4" />
    <rect x="475" y="125" width="33" height="34" rx="4" />
    <rect x="615" y="125" width="33" height="34" rx="4" />
    <rect x="755" y="125" width="33" height="34" rx="4" />
    <rect x="895" y="125" width="33" height="34" rx="4" />
    <rect x="1035" y="125" width="33" height="34" rx="4" />
    <rect x="335" y="160" width="33" height="34" rx="4" />
    <rect x="475" y="160" width="33" height="34" rx="4" />
    <rect x="615" y="160" width="33" height="34" rx="4" />
    <rect x="755" y="160" width="33" height="34" rx="4" />
    <rect x="895" y="160" width="33" height="34" rx="4" />
    <rect x="1035" y="160" width="33" height="34" rx="4" />
    <rect x="265" y="19" width="33" height="34" rx="4" />
    <rect x="405" y="19" width="33" height="34" rx="4" />
    <rect x="545" y="19" width="33" height="34" rx="4" />
    <rect x="685" y="19" width="33" height="34" rx="4" />
    <rect x="825" y="19" width="33" height="34" rx="4" />
    <rect x="965" y="19" width="33" height="34" rx="4" />
    <rect x="1105" y="19" width="33" height="34" rx="4" />
    <rect x="1175" y="19" width="33" height="34" rx="4" />
    <rect x="265" y="55" width="33" height="34" rx="4" />
    <rect x="405" y="55" width="33" height="34" rx="4" />
    <rect x="545" y="55" width="33" height="34" rx="4" />
    <rect x="685" y="55" width="33" height="34" rx="4" />
    <rect x="825" y="55" width="33" height="34" rx="4" />
    <rect x="965" y="55" width="33" height="34" rx="4" />
    <rect x="1105" y="55" width="33" height="34" rx="4" />
    <rect x="1175" y="55" width="33" height="34" rx="4" />
    <rect x="265" y="90" width="33" height="34" rx="4" />
    <rect x="405" y="90" width="33" height="34" rx="4" />
    <rect x="545" y="90" width="33" height="34" rx="4" />
    <rect x="685" y="90" width="33" height="34" rx="4" />
    <rect x="825" y="90" width="33" height="34" rx="4" />
    <rect x="965" y="90" width="33" height="34" rx="4" />
    <rect x="1105" y="90" width="33" height="34" rx="4" />
    <rect x="1175" y="90" width="33" height="34" rx="4" />
    <rect x="265" y="125" width="33" height="34" rx="4" />
    <rect x="405" y="125" width="33" height="34" rx="4" />
    <rect x="545" y="125" width="33" height="34" rx="4" />
    <rect x="685" y="125" width="33" height="34" rx="4" />
    <rect x="825" y="125" width="33" height="34" rx="4" />
    <rect x="965" y="125" width="33" height="34" rx="4" />
    <rect x="1105" y="125" width="33" height="34" rx="4" />
    <rect x="1175" y="125" width="33" height="34" rx="4" />
    <rect x="265" y="160" width="33" height="34" rx="4" />
    <rect x="405" y="160" width="33" height="34" rx="4" />
    <rect x="545" y="160" width="33" height="34" rx="4" />
    <rect x="685" y="160" width="33" height="34" rx="4" />
    <rect x="825" y="160" width="33" height="34" rx="4" />
    <rect x="965" y="160" width="33" height="34" rx="4" />
    <rect x="1105" y="160" width="33" height="34" rx="4" />
    <rect x="1175" y="160" width="33" height="34" rx="4" />
    <rect x="300" y="19" width="33" height="34" rx="4" />
    <rect x="440" y="19" width="33" height="34" rx="4" />
    <rect x="580" y="19" width="33" height="34" rx="4" />
    <rect x="720" y="19" width="33" height="34" rx="4" />
    <rect x="860" y="19" width="33" height="34" rx="4" />
    <rect x="1000" y="19" width="33" height="34" rx="4" />
    <rect x="1140" y="19" width="33" height="34" rx="4" />
    <rect x="1210" y="19" width="33" height="34" rx="4" />
    <rect x="300" y="55" width="33" height="34" rx="4" />
    <rect x="440" y="55" width="33" height="34" rx="4" />
    <rect x="580" y="55" width="33" height="34" rx="4" />
    <rect x="720" y="55" width="33" height="34" rx="4" />
    <rect x="860" y="55" width="33" height="34" rx="4" />
    <rect x="1000" y="55" width="33" height="34" rx="4" />
    <rect x="1140" y="55" width="33" height="34" rx="4" />
    <rect x="1210" y="55" width="33" height="34" rx="4" />
    <rect x="300" y="90" width="33" height="34" rx="4" />
    <rect x="440" y="90" width="33" height="34" rx="4" />
    <rect x="580" y="90" width="33" height="34" rx="4" />
    <rect x="720" y="90" width="33" height="34" rx="4" />
    <rect x="860" y="90" width="33" height="34" rx="4" />
    <rect x="1000" y="90" width="33" height="34" rx="4" />
    <rect x="1140" y="90" width="33" height="34" rx="4" />
    <rect x="1210" y="90" width="33" height="34" rx="4" />
    <rect x="300" y="125" width="33" height="34" rx="4" />
    <rect x="440" y="125" width="33" height="34" rx="4" />
    <rect x="580" y="125" width="33" height="34" rx="4" />
    <rect x="720" y="125" width="33" height="34" rx="4" />
    <rect x="860" y="125" width="33" height="34" rx="4" />
    <rect x="1000" y="125" width="33" height="34" rx="4" />
    <rect x="1140" y="125" width="33" height="34" rx="4" />
    <rect x="1210" y="125" width="33" height="34" rx="4" />
    <rect x="300" y="160" width="33" height="34" rx="4" />
    <rect x="440" y="160" width="33" height="34" rx="4" />
    <rect x="580" y="160" width="33" height="34" rx="4" />
    <rect x="720" y="160" width="33" height="34" rx="4" />
    <rect x="860" y="160" width="33" height="34" rx="4" />
    <rect x="1000" y="160" width="33" height="34" rx="4" />
    <rect x="1140" y="160" width="33" height="34" rx="4" />
    <rect x="1210" y="160" width="33" height="34" rx="4" />
  </content-loader>
</template>
